import React, { useEffect } from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import Tab from 'src/components/10-atoms/tabs/Tab';
import TabHeader from 'src/components/10-atoms/tabs/TabHeader';
import Tabs from 'src/components/10-atoms/tabs/Tabs';
import Page from 'src/components/templates/page/Page.template';
import PageNavbar from 'src/components/templates/page/PageNavbar.template';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
import GenericServerError from 'src/components/10-atoms/GenericServerError';
import QueryHandler from 'src/components/10-atoms/QueryHandler';
import useCallbackWithCtx from 'src/hooks/useCallbackUtils/useCallbackWithCtx';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { isWeb } from 'src/utils/platform';
import EPBreadCrumbs from '../../components/EPBreadCrumbs';
import analytics from './analytics';
import BookmarksTab from './container/BookmarksTab';
import DiagramsTab from './container/DiagramsTab';
import QBankTab from './container/QBankTab';
import QPTab from './container/QPTab';
import TopicList from './container/TopicList';
import useData from './useData';
const Subject = ({ navigation, route }) => {
    const { subject, examLevel, subjectID } = route.params;
    const [state, actions] = useData(subjectID);
    const [{ styles, theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    useEffect(() => {
        if (!subject) {
            actions.subjectDetailsQuery.fetch();
        }
    }, []);
    const ancestorsDetails = state.subjectDetailsQuery.data?.ep_subjectDetails.ancestorsDetails;
    const subjectDetails = subject || state.subjectDetailsQuery.data?.ep_subjectDetails;
    const examLevelDetails = examLevel || ancestorsDetails?.examLevel;
    const handleTopicPress = useCallbackWithCtx((ctx, topic) => {
        if (!ctx.subject) {
            return;
        }
        analytics.setWidget('TopicList').setTarget('Topic').click();
        navigation.navigate('EP_TopicQuestions', {
            ...(!isWeb && {
                examLevel: ctx.examLevel,
                subject: ctx.subject,
            }),
            ancestorID: ctx.subject.id,
            topic: topic.id,
        });
    }, {
        subject: subjectDetails,
        examLevel: examLevelDetails,
    });
    const handleQPPress = useCallbackWithCtx((ctx, questionPaper) => {
        analytics
            .setWidget('QuestionPaperList')
            .setTarget('QuestionPaper')
            .click();
        navigation.navigate('EP_QP', {
            ...(!isWeb && {
                examLevel: ctx.examLevel,
                subject: ctx.subject,
                qp: questionPaper,
            }),
            qpID: questionPaper.id,
        });
    }, { examLevel: examLevelDetails, subject: subjectDetails });
    const handleQBankQuestionPress = useStableCallback((question, index) => {
        analytics
            .setWidget('QBank_QuestionList')
            .setTarget('Question')
            .click();
        navigation.navigate('EP_Question', {
            questionID: question.id,
            navigatedFrom: 'Q_BANK_QUESTIONS',
            navigationData: {
                sequence: index,
                filters: {
                    ...route.params.filters,
                    ancestorID: subjectID,
                }
            }
        });
    });
    const handleBookmarkPress = useStableCallback((question, index) => {
        analytics
            .setWidget('Bookmarks_QuestionList')
            .setTarget('Question')
            .click();
        navigation.navigate('EP_Question', {
            questionID: question.id,
            navigatedFrom: 'Q_BANK_QUESTIONS',
            navigationData: {
                sequence: index,
                filters: {
                    ancestorID: subjectID,
                    bookmarked: true,
                }
            }
        });
    });
    const handleDiagramRefQuestionPress = useStableCallback((question) => {
        analytics
            .setWidget('Diagram_refQuestionList')
            .setTarget('Question')
            .click();
        // navigation.navigate('EP_Question', {
        //   questionID: question.id,
        //   navigatedFrom: 'Q_BANK_QUESTIONS',
        //   navigationData: {
        //     sequence: index,
        //     filters: {
        //       ...route.params.filters,
        //       ancestorID: subjectID,
        //     }
        //   }
        // })
    });
    const breadCrumbsLoading = !examLevel && state.subjectDetailsQuery.loading;
    return (React.createElement(Page, null,
        React.createElement(Column, { bbw: 1 },
            React.createElement(PageNavbar, { backType: "back", title: translate('Subject'), onBackPress: navigation.goBack }),
            React.createElement(Column, { style: styles.header },
                React.createElement(Row, { alignSelf: 'stretch', yAxis: 'center', ph: theme.spacing.page },
                    React.createElement(EPBreadCrumbs, { loading: breadCrumbsLoading, visibleCount: 1, knownNodes: {
                            examLevel: examLevelDetails,
                            subject: subjectDetails,
                        }, ph: 0, style: { maxWidth: '100%' } })),
                React.createElement(TabHeader, { ph: theme.spacing.standard.xs, tabs: state.tabs.tabs, activeIndex: state.tabs.activeIndex, onChange: (index) => {
                        analytics
                            .setWidget('GroupBy')
                            .setTarget(state.tabs.tabs[index].id)
                            .click();
                        actions.tabs.setActiveIndex(index);
                    } }))),
        React.createElement(QueryHandler, { skip: !!subjectDetails, queryState: state.subjectDetailsQuery, LoaderComponent: null, ErrorComponent: React.createElement(GenericServerError, { onRetry: actions.subjectDetailsQuery.fetch }), DataComponent: React.createElement(Tabs, { activeTab: state.tabs.tabs[state.tabs.activeIndex]?.id },
                React.createElement(Tab, { id: "PAPERS" },
                    React.createElement(QPTab, { subject: subjectDetails, subjectID: subjectID, onQPPress: handleQPPress })),
                React.createElement(Tab, { id: "TOPICS" },
                    React.createElement(TopicList, { subjectID: subjectID, onTopicPress: handleTopicPress })),
                React.createElement(Tab, { id: "BOOKMARKS" },
                    React.createElement(BookmarksTab, { subjectID: subjectID, onQuestionPress: handleBookmarkPress })),
                React.createElement(Tab, { id: "DIAGRAMS" },
                    React.createElement(DiagramsTab, { subjectID: subjectID, onQuestionPress: handleDiagramRefQuestionPress })),
                React.createElement(Tab, { id: "QUESTION_BANK" },
                    React.createElement(QBankTab, { subjectID: subjectID, onQuestionPress: handleQBankQuestionPress }))) })));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    header: {
        backgroundColor: theme.palette.background.main,
    },
}));
export default Subject;
